import { apiGet, apiPost, apiPut, apiDelete, getDeviceType } from '../../../utils';


export function getAllFirmwareAPI(filters) {
  let arr = []
  for (const [key, value] of Object.entries(filters)) {
    if (key === "isOpen" || key === 'deviceType') continue
    if (typeof value !== "number" && !value?.length) continue

    if (["status"].includes(key)) {
      arr.push({ key, value, type: 'multi' })
    } else {
      arr.push({ key, value, type: "single" })
    }
  }
  return apiGet(`/api/ota/get?filter=${JSON.stringify(arr)}&deviceType=${filters?.deviceType || "livelink"}`)
}

export function createFirmwareAPI(data) {
  const formData = new FormData()

  data.fileToUpload.forEach(item => {
    formData.append(item.key, item.file)
    if (data.ota_type === "multiple") {
      formData.append(item.md_5_Key, item[item.md_5_Key])
    }
  })
  formData.append("version", data.firmwareVersion)
  formData.append("mcu_version", data.mcu_version)
  formData.append("deviceType", data.deviceType)
  formData.append("ota_type", data.ota_type)
  formData.append("auto_update_message", data.auto_update_message || "")
  formData.append("manual_update_message", data.manual_update_message || "")
  if (data.ota_type === "single") {
    formData.append("md_5_value", data.md_5_value || "")
  }

  return apiPost('/api/ota/store', formData)
}


export function updateFirmwareAPI(data) {
  const formData = new FormData()
  data.fileToUpload.forEach(item => {
    formData.append(item.key, item.file)
    if (data.ota_type === "multiple") {
      formData.append(item.md_5_Key, item[item.md_5_Key])
    }
  })
  formData.append("version", data.firmwareVersion)
  formData.append("mcu_version", data.mcu_version)
  formData.append("deviceType", data?.deviceType)
  formData.append("ota_type", data.ota_type)
  formData.append("auto_update_message", data.auto_update_message || "")
  formData.append("manual_update_message", data.manual_update_message || "")
  if (data.ota_type === "single") {
    formData.append("md_5_value", data.md_5_value || "")
  }

  return apiPost(`/api/ota/update/${data.selectedId}`, formData)
}

export function deleteFirmwareAPI(id, deviceType) {
  let obj = {
    ota_id: id,
    "deviceType": getDeviceType(deviceType)
  }
  return apiDelete('/api/ota/delete', obj)
}



